<template>
  <div class="redpack">
    <div class="redpack-contain">
      <div class="redpack-left" :class="{ 'redpack-left-none': redpackObj.status != 0 && redpackObj.status != 50 }">
        <p class="redpack-left-label" v-if="formatDay(redpackObj)">{{ formatDay(redpackObj) }}</p>
        <div class="redpack-left-price"
          :class="{ 'redpack-left-price-none': redpackObj.status != 0 && redpackObj.status != 50 }">
          <p class="price-nums" v-if="redpackObj.batchType == 1">
            <span class="price-num">{{ redpackObj.augmentCost }}</span>
            <span class="price-unit"
              :style="{ color: redpackObj.status != 0 && redpackObj.status != 50 ? '#999' : '' }">{{ redpackObj.unit
              }}</span>
            <span v-if="redpackObj && redpackObj.mark && redpackObj.mark == 1" class="price-best"
              :style="{ color: redpackObj.status != 0 && redpackObj.status != 50 ? '#999' : '' }">最<br />高</span>
          </p>
          <!-- 免息券 -->
          <div class="price-free" v-else-if="redpackObj.batchType == 3">
            <p class="price-free-title"
              :style="{ color: redpackObj.status != 0 && redpackObj.status != 50 ? '#999' : '' }">{{
                redpackObj.augmentCost
              }}</p>
            <p class="price-free-project" :style="{
                  color: redpackObj.status != 0 && redpackObj.status != 50 ? '#999' : '',
                  backgroundColor: redpackObj.status != 0 && redpackObj.status != 50 ? 'rgba(178, 178, 178, 0.5)' : '',
                }">{{ redpackObj.projectName }}</p>
          </div>
          <!--4为兑换券-->
          <p class="price-nums" v-else-if="redpackObj.batchType == 4">
            <span class="price-type">兑换券</span>
          </p>
          <p class="price-nums" v-else>
            <span class="price-icon">￥</span>
            <span class="price-num">{{ redpackObj.reduceCost }}</span>
            <span v-if="redpackObj && redpackObj.mark && redpackObj.mark == 1" class="price-best"
              :style="{ color: redpackObj.status != 0 && redpackObj.status != 50 ? '#999' : '' }">最<br />高</span>
          </p>
          <!--10001是餐饮券-->
          <p class="price-name" v-if="redpackObj.projectId == '10001'">餐饮</p>
          <p class="price-name" v-else-if="redpackObj.batchType !== 3">
            {{ redpackObj.projectName }}
          </p>
        </div>
      </div>
      <div class="redpack-right">
        <div class="redpack-right-top">
          <div class="title" :class="{ 'title-none': redpackObj.status != 0 && redpackObj.status != 50 }">
            {{ redpackObj.title }}
          </div>
        </div>
        <div class="redpack-right-mid">
          <div class="info">
            <div class="subTitle">{{ redpackObj.useRule }}</div>
            <div class="useScene" v-if="redpackObj.useScene">{{ redpackObj.useScene }}</div>
          </div>

          <div class="btn" :class="{ 'btn-none': redpackObj.status != 0 && redpackObj.status != 50 }"
            @click="toUse(redpackObj)">
            {{ redpackBtnTxt(redpackObj) }}
          </div>
          <div class="tip" v-if="redpackObj.recoveryMoney && redpackObj.status == 50">最高回收¥{{ redpackObj.recoveryMoney }}
          </div>
        </div>
        <div class="redpack-right-bottom">
          <div class="validTime">{{ redpackObj.validTime }}</div>
          <div class="useRule"
            v-if="(redpackObj.status == 0 || redpackObj.status == 2 || redpackObj.status == 50) && redpackObj.description"
            @click="openRule(redpackObj)">
            <span>使用说明</span>
            <img v-if="!redpackObj.isRule" src="https://file.40017.cn/appresource/image/voucher/v-down.png" alt />
            <img v-else src="https://file.40017.cn/appresource/image/voucher/v-up.png" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="redpack-rule" v-if="redpackObj.isRule">
      <div class="redpack-rule-line"></div>
      <span v-html="redpackObj.description"></span>
      <!-- 国内机票 -->
      <p class="redpack-rule-ignore" v-if="this.redpackObj.projectId == 2" @click="flightRuleEvt"> 红包/代金券使用规则明细 > </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'redpack',
  props: {
    redpackObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    trackInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    memberId: {
      type: String,
      default: ''
    },
    hwPreInstallRefid: {
      type: String,
      default: ''
    },
  },
  components: {},
  data() {
    return {
    };
  },
  computed: {
    formatDay() {
      return (obj) => {
        // 1新券  2今日过期  3明日过期 4 x日内过期 5今日生效 6明日生效 7x日后生效
        switch (obj.receiveStatus) {
          case 1:
            return '新券';
          case 2:
            return '今日过期';
          case 3:
            return '明日过期';
          case 4:
            return obj.expirationDays > 0 ? `${obj.expirationDays}日后过期` : '七日后过期';
          case 5:
            return '今日生效';
          case 6:
            return '明日生效';
          case 7:
            return obj.expirationDays > 0 ? `${obj.expirationDays}日后生效` : '七日后生效';
          default:
            return '';
        }
      };
    },
    redpackBtnTxt() {
      return function (obj) {
        switch (obj.status) {
          case 0:
            return '去使用';
          case 1:
            return '已使用';
          case 2:
            return '未生效';
          case 3:
            return '已过期';
          case 4:
            return '已作废';
          case 50:
            return '去回收';
          default:
            break;
        }
      };
    },
  },
  watch: {
    redpackObj(newVal) {
      if (newVal) {

        this.refid = this.trackInfo.refid || '0000';
        this.track('我的优惠券曝光', `{"channel":"领券中心","scene":"公共","项目tab":"${this.trackInfo.tab1}","属性tab":"${this.trackInfo.tab2}",“name”:"${this.redpackObj.reduceCost + '元' + this.redpackObj.projectName}","refid":"${this.refid}"}`, 'coupon_my_show');
      }
    },
  },

  created() { },
  mounted() {

    this.refid = this.trackInfo.refid || '0000';
    this.track('我的优惠券曝光', `{"channel":"领券中心","scene":"公共","项目tab":"${this.trackInfo.tab1}","属性tab":"${this.trackInfo.tab2}",“name”:"${this.redpackObj.reduceCost + '元' + this.redpackObj.projectName}","refid":"${this.refid}"}`, 'coupon_my_show');
  },
  destroyed() { },
  methods: {
    flightRuleEvt() {
      let url = 'https://m.17u.cn/propublic/tvoucher/rule?wvc3=1';
      if (process.env.VUE_APP_ENV == 'development') {
        url = `${window.location.origin}/tvoucher/rule?wvc3=1`;
      } else {
        url = `${process.env.VUE_APP_BASE_H5_ALL_URL}/propublic/tvoucher/rule?wvc3=1`;
      }
      _multi_bridge.navigateTo({ url: url });
    },

    openRule(obj) {
      if (obj.status == 0 || obj.status == 1 || obj.status == 2 || obj.status == 50) {
        obj.isRule = !obj.isRule;
      }
    },
    toUse(obj) {
      this.track('我的优惠券点击', `{"channel":"红包优惠券","项目tab":"${this.trackInfo.tab1}","属性tab":"${this.trackInfo.tab2}",“name”:"${this.redpackObj.reduceCost + '元' + this.redpackObj.projectName}","refid":"${this.refid}"}`, 'coupon_myexchange_click');
      if (obj.status == 0 || obj.status == 1) {
        console.log('toUse:', obj);
        const { projectId, appUrl } = obj
        let url = appUrl
        if (projectId === 1) { // 火车票 
          url = 'tctclient://train/home?refid=2000065856'
        } else if (projectId === 3) { // 酒店
          url = `https://m.ly.com/hotel/?pageType=0&ref=tcandroid1&of=5010047&refid=${this.hwPreInstallRefid || '2000065856'}`
        }  else if (projectId === 4) { // 景区
          url = 'https://m.ly.com/scenery_1/?hwpremid=tcwvmid'
        } else if (projectId === 5) { // 用车
          url = 'https://m.ly.com/car/view/main.html#/specialCarIndex/instantCar?index=specialCarIndex&isUseNewTab=true&refId=1886774961&channel=2000065856'
        } else if (projectId === 2) { // 机票
          url = 'tctclient://flight/home?refid=2000065856'
        } else if (projectId === 6) { // 汽车票
          url = 'https://m.ly.com/bus/?refid=2000065856#/'
        } else if (projectId === 42) { // 度假
          url = 'https://m.ly.com/journey/index?wvc6=1&head=1&refid=77130605&modid=mjhIClsa1'
        }
        _multi_bridge.navigateTo({ url: url });
      } else {
        return;
      }
    },
    track(label, value, action, category) {
      _multi_bridge_ready(() => {
        _multi_bridge.trackData({
          pname: '我的优惠券',
          category: category || 'cvg2021_apppublic_mycouponpage',
          action: action,
          id: label,
          value: encodeURIComponent(value),
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
@redpackbg: #fff2ed;
@redpackprice: #ff6257;

.redpack {
  display: flex;
  flex-direction: column;
  height: auto;
  margin: 10px 16px 0 16px;
  background: #ffffff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.08);
  border-radius: 10px;

  &-contain {
    display: flex;

    // height: 100%;
    .redpack-left {
      position: relative;
      display: flex;
      justify-content: center;
      min-width: 100px;
      // height: 96px;
      background: @redpackbg;
      border: 1px @redpackbg;
      border-right-style: dashed;
      border-radius: 10px 0 0 10px;
      padding-right: 10px;

      &-label {
        position: absolute;
        top: 0;
        left: 0;
        padding: 0 10px;
        // width: 82px;
        height: 17px;
        background: @redpackprice;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.08);
        border-radius: 10px 0 8px 0;
        font-size: 10px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 18px;
        text-align: center;

        img {
          width: 3px;
          height: 6px;
        }
      }

      &-price {
        color: @redpackprice;
        display: flex;
        flex-direction: column;
        align-items: center;

        .price-nums {
          display: flex;
          align-items: center;
          margin-top: 28px;

          .price-icon {
            width: 14px;
            height: 14px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 600;
            line-height: 14px;
            margin-top: 10px;
          }

          .price-num {
            display: inline-block;
            height: 28px;
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 28px;
          }

          .price-type {
            display: inline-block;
            height: 28px;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 28px;
          }

          .price-unit {
            width: 18px;
            height: 14px;
            margin-top: 8px;
            margin-left: 3px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ff6257;
            line-height: 14px;
            text-shadow: 0px 0px 0px rgba(0, 0, 0, 0.08);
          }

          .price-best {
            margin-left: 2px;
            line-height: 10px;
            color: #ff6257;
            font-size: 9px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            // writing-mode: vertical-rl;
            // writing-mode: vertical-lr;
          }
        }

        .price-free {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          width: 100%;

          &-title {
            font-family: PingFangSC-Semibold;
            font-weight: bold;
            font-size: 18px;
            color: #ff6257;
            line-height: 14px;
          }

          &-project {
            width: 35px;
            height: 21px;
            line-height: 22px;
            background: #ffe3d9;
            border-radius: 5px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 12px;
            margin-top: 11px;
            color: #ff6257;
            text-align: center;
          }
        }

        .price-name {
          height: 18px;
          margin-top: 6px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          line-height: 18px;
          text-align: center;
        }
      }

      &-price-none {
        color: #999;
      }
    }

    .redpack-left-none {
      background: #fbfbfb;
      border: 1px #fbfbfb;
    }

    .redpack-right {
      width: 75%;
      height: 100%;
      // position: relative;

      &-top {
        width: 220px;
        height: 18px;
        margin: 12px 0 0 12px;

        .title {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 700;
          color: #333333;
          line-height: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .title-none {
          color: #999;
        }
      }

      &-mid {
        display: flex;
        justify-content: space-between;
        margin: 6px 12px 0 12px;
        position: relative;
        height: 45px;


        .info {
          position: relative;

          .subTitle {
            width: 143px;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #b2b2b2;
            line-height: 16px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }

          .useScene {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 10px;
            color: #B2B2B2;
            letter-spacing: -0.24px;
            line-height: 16px;
          }
        }

        .tip {
          position: absolute;
          right: 0;
          top: -4px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 10px;
          color: #ff6257;
          letter-spacing: 0;
          text-align: center;
          line-height: 12px;
        }

        .btn {
          width: 64px;
          height: 28px;
          box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.08);
          border-radius: 14px;
          border: 1px solid @redpackprice;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: @redpackprice;
          line-height: 28px;
          text-align: center;
          margin-top: 10px;
        }

        .btn-none {
          color: #999;
          box-shadow: none;
          border: 1px solid rgb(178, 178, 178, 0.3);
        }
      }


      &-bottom {
        display: flex;
        justify-content: space-between;
        height: 16px;
        margin: 8px 7px 3px 12px;

        .validTime {
          width: 147px;
          height: 16px;
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #b2b2b2;
          line-height: 16px;
        }

        .useRule {
          display: flex;
          align-items: center;

          span {
            height: 14px;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #b2b2b2;
            line-height: 14px;
          }

          img {
            width: 14px;
            height: 11px;
          }
        }
      }
    }
  }

  &-rule {
    height: auto;
    padding: 12px 18px;
    background: #ffffff;
    border-radius: 0 0 12px 12px;
    position: relative;

    &-line {
      border-block-start: 1px dashed #f0f0f0;
      position: absolute;
      top: -1px;
      right: 0;
      left: 110px;
      height: 1px;
    }

    &-ignore {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 10px;
      color: #06c584;
      margin-top: 5px;
    }

    span {
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #b2b2b2;
      line-height: 18px;
    }
  }
}
</style>
